import React, {Component} from 'react';
import AUX from '../../hoc/Aux_';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link } from 'react-router-dom';
import { withRouter, Redirect } from "react-router";
import { generateRDFAll, generateRDFCatalogOnly, generateRDFloop, generateRDFloopx } from '../../api/featurecatalog';
import {BarLoader} from "react-spinners";
import { css } from "@emotion/core";

const override = css`
position: absolute;
  top: 50%;
  left: 35%;
  margin: 0 auto;
`;

class Generaterdf extends Component{

  constructor(props) {
    super(props);
    this.state = {
      featureCatalog : null,
      loading: false,
      status: ""
    }
  }

  componentWillMount(){
    if(localStorage.getItem('token')==null){

      console.log(localStorage.getItem('token'));
      this.props.history.push(`/login`);
    }
  }

  generateRDFAll = () => {
    generateRDFAll()
      .then(response => {
        console.log(response); 
        this.generateRDFCatalogOnly();
    }).catch(error => {
      console.log(error);
      this.setState({status:error});
    });
  }

  generateRDFCatalogOnly = ()=>{
    generateRDFCatalogOnly()
      .then(response => {
        //this.setState({loading:false});
        this.generateRDFloop();
    }).catch(error => {
      console.log(error);
      this.setState({status:error});
    });
  }

  generateRDFloop = ()=> {
    generateRDFloop()
      .then(response => {
         this.generateRDFloopx();
        //this.setState({loading:false});
    }).catch(error => {
      console.log(error);
      this.setState({status:error});
    });
  }

  generateRDFloopx = ()=>{
    generateRDFloopx()
      .then(response => {
        console.log(response);
        this.setState({loading:false, status: "selesai"});
    }).catch(error => {
      console.log(error);
      this.setState({status:error});
    });
  }

  submitForm = () => {
    this.setState({loading:true});
    this.generateRDFAll();
  }



  render(){
    return (
      <AUX>
      <div className="sweet-loading">
        <BarLoader
          css={override}
          height={5}
          width={400}
          color={"#C51162"}
          loading={this.state.loading}
        />
      </div>

      <section className="sections" style = {{paddingTop:"5%"}}>

        <div className="container">
        <Breadcrumbs aria-label="breadcrumb">

        </Breadcrumbs>
          <div className="row justify-content-center" >

            <p>Perhatian! Jangan tutup ini sampai proses selesai</p>

          </div>
          <div className="row justify-content-center" >
            <h4><font color="red">{this.state.status}</font></h4>

          </div>

          <div className="row justify-content-center" >

            <p><Button variant="contained" color="secondary" onClick = {this.submitForm}>GENERATE RDF</Button></p>

          </div>
        </div>
      </section>
      <br/>
      </AUX>
    )
  }
}

export default withRouter(Generaterdf);
